"use client"

let currentTheme = null;

function themeSwitcher() {
    if (typeof window !== 'undefined') {
        localStorage.getItem('theme-auto-switch') ? null : (localStorage.setItem('theme-auto-switch', 1), localStorage.setItem('theme', currentTheme));
        if ((localStorage.getItem('theme-auto-switch') && localStorage.getItem('theme-auto-switch') === "1") || !localStorage.getItem('theme-auto-switch')) {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                // dark mode
                currentTheme = 'dark';
                localStorage.setItem('theme', 'dark');
                console.log(`Current Device theme: ${currentTheme}`);
                document.body.classList.add("dark");
            } else {
                currentTheme = 'light';
                localStorage.setItem('theme', 'light');
                document.body.classList.remove("dark");
                console.log(`Current Device Theme : ${currentTheme}`);
            }
        }
    }
}

// run 
themeSwitcher();

if (typeof window !== 'undefined') {
    //  change detection 
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
        themeSwitcher();
        const newColorScheme = event.matches ? ("dark", localStorage.setItem('theme', 'dark')) : ("light", localStorage.setItem('theme', 'light'));
        console.log(newColorScheme);
    })
}


const DisableAutoThemeSwitch = () => {
    if (typeof window !== 'undefined') {
        console.log('disableAutoThemeSwitch !');
        localStorage.setItem('theme-auto-switch', 0);
        document.getElementById('theme-switcher').style.bottom = "-150px";
        return (null);
    }
}

export default DisableAutoThemeSwitch;